<template>
    <div class="stars">
        <img v-for="index in roundedRating" :key="index + '-gold'" :src="starFile" />
        <img v-if="Math.round(rating) - roundedRating > 0" src="@/assets/icons/other/star-half.svg" />
        <img v-for="index in 5 - Math.round(rating)" :key="index + '-faded'" :src="starFile" style="opacity: 0.4" />
    </div>
</template>

<script>
export default {
    name: "StarRating",
    props: {
        rating: Number,
        gold: Boolean
    },
    computed: {
        roundedRating() {
            return this.rating | 0;
        },
        starFile() {
            return require(`@/assets/icons/other/star${this.gold ? "-gold" : ""}.svg`);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.stars {
    line-height: 200%;

    img {
        margin: 0px 1px;
    }
}
</style>
